/*
 *
 * CollaboratorsCreate constants
 *
 */

export const DEFAULT_ACTION = "app/CollaboratorsCreate/DEFAULT_ACTION"

export const GET_DIVISIONS_WATCHER =
  "app/CollaboratorsCreate/GET_DIVISIONS_WATCHER"
export const GET_DIVISIONS_SUCCESS =
  "app/CollaboratorsCreate/GET_DIVISIONS_SUCCESS"
export const GET_DIVISIONS_FAILED =
  "app/CollaboratorsCreate/GET_DIVISIONS_FAILED"

export const GET_CATEGORIES_WATCHER =
  "app/CollaboratorsCreate/GET_CATEGORIES_WATCHER"
export const GET_CATEGORIES_SUCCESS =
  "app/CollaboratorsCreate/GET_CATEGORIES_SUCCESS"
export const GET_CATEGORIES_FAILED =
  "app/CollboratorsCreate/GET_CATEGORIES_FAILED"

export const GET_CURRENCY_WATCHER =
  "app/CollaboratorsCreate/GET_CURRENCY_WATCHER"
export const GET_CURRENCY_SUCCESS =
  "app/CollaboratorsCreate/GET_CURRENCY_SUCCESS"
export const GET_CURRENCY_FAILED = "app/CollaboratorsCreate/GET_CURRENCY_FAILED"

export const CREATE_COLLABORATOR_WATCHER =
  "app/CollaboratorsCreate/CREATE_COLLABORATOR_WATCHER"
export const CREATE_COLLABORATOR_SUCCESS =
  "app/CollaboratorsCreate/CREATE_COLLABORATOR_SUCCESS"
export const CREATE_COLLABORATOR_FAILED =
  "app/CollaboratorsCreate/CREATE_COLLABORATOR_FAILED"

export const GET_GENDERS_WATCHER =
  "app/CollaboratorsCreate/GET_GENDERS_WATCHER"
export const GET_GENDERS_SUCCESS = "app/CollaboratorsCreate/GET_GENDERS_SUCCESS"
export const GET_GENDERS_FAILED = "app/CollaboratorsCreate/GET_GENDERS_FAILED"

export const GET_EMPLOYEES_WATCHER = "app/CollaboratorsCreate/GET_EMPLOYEES_WATCHER"
export const GET_EMPLOYEES_SUCCESS = "app/CollaboratorsCreate/GET_EMPLOYEES_SUCCESS"
export const GET_EMPLOYEES_FAILED = "app/CollaboratorsCreate/GET_EMPLOYEES_FAILED"

export const GET_LOCATIONS_WATCHER = "app/CollaboratorsCreate/GET_LOCATIONS_WATCHER"
export const GET_LOCATIONS_SUCCESS = "app/CollaboratorsCreate/GET_LOCATIONS_SUCCESS"
export const GET_LOCATIONS_FAILED = "app/CollaboratorsCreate/GET_LOCATIONS_FAILED"